/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Checkbox, colors, Icon, Text, VFlow } from 'bold-ui'
import { useState } from 'react'

import { ImunobiologicoRow, ImunobiologicoRowProps } from './ImunobiologicoRow'

export interface VacinacaoPanelProps {
  outrosImunobiologicos?: boolean
  imunobiologicos: ImunobiologicoRowProps[]
}

export function VacinacaoPanel(props: VacinacaoPanelProps) {
  const { outrosImunobiologicos, imunobiologicos } = props

  const [mostrarCalendarioCompleto, setMostrarCalendarioCompleto] = useState<boolean>(false)
  return (
    <VFlow vSpacing={0.25}>
      {outrosImunobiologicos ? (
        <Button kind='primary' size='small' onClick={(event) => {}}>
          <Icon icon='plus' style={{ marginRight: '0.5rem' }} />
          Adicionar dose
        </Button>
      ) : (
        <div
          css={css`
            background-color: ${colors.gray.c90};
            padding: 0.5rem 1rem;
          `}
        >
          <Checkbox
            label='Mostrar calendário nacional completo'
            onClick={() => setMostrarCalendarioCompleto(!mostrarCalendarioCompleto)}
          />
        </div>
      )}
      {imunobiologicos?.length > 0 ? (
        imunobiologicos
          .filter((value) =>
            value.model.doses.find((dose) => dose.model.mostrarNoCalendarioDoGrupo || mostrarCalendarioCompleto)
          )
          .map((value) => (
            <ImunobiologicoRow
              key={value.model.imunobiologicoId}
              mostrarCalendarioCompleto={mostrarCalendarioCompleto}
              {...value}
            />
          ))
      ) : (
        <div style={{ margin: '0.5rem 0rem' }}>
          <Text fontStyle='italic'>Nenhum outro imunobiológico registrado para o cidadão.</Text>
        </div>
      )}
    </VFlow>
  )
}
